//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  name: 'LyricsBar',

  computed: {
    ...mapState('AudioPlayer', [
      'currentLyric'
    ]),
  },

  data () {
    return {
      beTouched: false,

      // 鼠标按下时的位置
      startX: 0,
      startY: 0,

      fontSize: 0, // rem
      
      showSizeBar: false,
      laterTimer: 0,
    }
  },

  watch: {
    fontSize(newv, oldv) {
      if (oldv > 0) this.showTempSizeBar()
    }
  },

  methods: {
    showTempSizeBar() {
      // return // debug only
      clearTimeout(this.laterTimer);
      this.showSizeBar = true;
      this.laterTimer = setTimeout(() => {
        this.showSizeBar = false;
      }, 3 * 1000); // 延迟关闭滑块
    },

    /**
     * @param {TouchEvent|MouseEvent} ev
     */
    getTouch(ev) {
      return ev.touches ? ev.touches[0] : ev;
    },

    onCursorDown(ev) {
      this.showTempSizeBar()
      ev.preventDefault()
      this.beTouched = true

      // 移动端使用 ev.touches[0]
      const touch = this.getTouch(ev)
      this.startX = touch.clientX - this.$refs.draggable.offsetLeft
      this.startY = touch.clientY - this.$refs.draggable.offsetTop
    },

    onCursorUp(ev) {
      if (!this.beTouched) return
      ev.preventDefault()
      this.beTouched = false
    },

    onCursorMove(ev) {
      if (!this.beTouched) { return }
      // ev.preventDefault()
      const touch = this.getTouch(ev)

      // 计算 element 新位置坐标
      const eleX = touch.clientX - this.startX
      const eleY = touch.clientY - this.startY

      this.$refs.draggable.style.left = eleX + 'px'
      this.$refs.draggable.style.top = eleY + 'px'
    },

    // 用户松开滑块之后才会触发此方法
    onFontSizeChange(v) {
      console.warn("fontSize change to: ", v)
      localStorage.lyricFontSize = v;
    }
    
  },

  mounted() {
    this.fontSize = parseFloat(localStorage.lyricFontSize || "1.5");
    // addEventListener('mousemove', onCursorMove(this), false)
    // addEventListener('touchmove', onCursorMove(this), false)
    addEventListener('mousemove', this.onCursorMove)
    addEventListener('touchmove', this.onCursorMove)

    addEventListener('mouseup', this.onCursorUp)
    addEventListener('touchend', this.onCursorUp)
    addEventListener('touchcancel', this.onCursorUp)
  },

  beforeDestroy() {
    removeEventListener('mousemove', this.onCursorMove)
    removeEventListener('touchmove', this.onCursorMove)

    removeEventListener('mouseup', this.onCursorUp)
    removeEventListener('touchend', this.onCursorUp)
    removeEventListener('touchcancel', this.onCursorUp)
  }
  
}
